"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BROADCAST_STATUS_OPTIONS = exports.BROADCAST_STATUS_BADGE_CLASS = exports.BROADCAST_STATUS_LABELS = void 0;
exports.BROADCAST_STATUS_LABELS = {
    SCHEDULED: '촬영예정',
    SHOOTING_DONE: '촬영완료',
    AIRED: '방송완료',
    CANCELLED: '취소',
};
exports.BROADCAST_STATUS_BADGE_CLASS = {
    SCHEDULED: 'badge-soft badge-neutral',
    SHOOTING_DONE: 'badge-soft badge-primary',
    AIRED: 'badge-soft badge-success',
    CANCELLED: 'badge-soft badge-error',
};
exports.BROADCAST_STATUS_OPTIONS = [
    { value: 'SCHEDULED', label: '촬영예정' },
    { value: 'SHOOTING_DONE', label: '촬영완료' },
    { value: 'AIRED', label: '방송완료' },
    { value: 'CANCELLED', label: '취소' },
];
